import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Heading for a content row. `to` renders a "see all" link on the right;
 * pass `onAction` instead when the action is not a plain route.
 */
const SectionHeader = ({ title, eyebrow, icon, to, onAction, actionLabel = 'Смотреть все', as: Tag = 'h2', className = '' }) => (
    <div className={['section-header', className].filter(Boolean).join(' ')}>
        <div className="section-header__text">
            {eyebrow ? <p className="section-header__eyebrow">{eyebrow}</p> : null}
            <Tag className="section-header__title">
                {icon ? <span className="section-header__icon"><img src={icon} alt="" /></span> : null}
                {title}
            </Tag>
        </div>
        {to ? (
            <Link to={to} className="ui-btn ui-btn--secondary ui-btn--sm section-header__link">{actionLabel}</Link>
        ) : null}
        {!to && onAction ? (
            <button type="button" onClick={onAction} className="ui-btn ui-btn--secondary ui-btn--sm section-header__link">{actionLabel}</button>
        ) : null}
    </div>
);

export default SectionHeader;
